import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import i18next from "i18next";


class DateTimeActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async getAll() {
        try {
            const request = new ApiRequest(`/Sample/GetRegionalTimeSettings`, "", null, i18next.t("Internal server error!"));
            const result = await this.api.get(request);
            const payload = result.data;
            
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_GET_DATE_FORMAT,
                payload: {
                    dateTimeFormatList: payload
                }
            });

        } catch (error) {
            throw error;
        }
    }

}

const dateTimeActions = new DateTimeActions();
export default dateTimeActions;